import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "Выберите тариф", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "avia-tarif-modal__title" }, "Выберите тарифный план", -1)
const _hoisted_3 = { class: "avia-tarif-modal-options" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_avia_tarif_plan = _resolveComponent("avia-tarif-plan")
  const _component_search_card_footer = _resolveComponent("search-card-footer")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.localDisplay,
      "onUpdate:visible": _cache[1] || (_cache[1] = $event => (_ctx.localDisplay = $event)),
      dismissableMask: true,
      class: "p-dialog--aviatarif",
      modal: true,
      onShow: _ctx.loadData
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataPrice, (variantPrice, groupIndex) => {
            return (_openBlock(), _createBlock(_Fragment, null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(variantPrice.itinerary, (plane) => {
                return (_openBlock(), _createBlock(_component_avia_tarif_plan, {
                  class: { 'avia-tarif-modal-plan--active': _ctx.isSelect(plane.key) },
                  pricePlane: plane,
                  key: plane.key + ' ' + groupIndex,
                  onClick: $event => (_ctx.setSelectTarif(plane.key, groupIndex))
                }, null, 8, ["class", "pricePlane", "onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _createVNode(_component_search_card_footer, {
          showPrice: false,
          class: "avia-tarif-modal__footer",
          toggleDisplay: _ctx.save
        }, null, 8, ["toggleDisplay"])
      ]),
      _: 1
    }, 8, ["visible", "onShow"])
  ]))
}